import { privateInstance } from "../configs";

export const localisationApi = {
  async getLocalisations() {
    const res = await privateInstance.get("main/api/store/localisation/list/");
    return res.data;
  },
  async postLocalisation(localisation) {
    const res = await privateInstance.post(
      "main/api/store/localisation/list/",
      localisation
    );
    return res.data;
  },
  async putLocalisation(id, localisation) {
    const res = await privateInstance.put(
      `main/api/store/localisation/rud/${id}/`,
      localisation
    );
    return res.data;
  }
};
